export default "__VITE_ASSET__Bf6ULBWF__"